var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"gutter":24}},[_c('Col',{attrs:{"span":"24"}},[_c('h4',[_vm._v(_vm._s(_vm.model[_vm.visitType]))]),_c('div',{directives:[{name:"height",rawName:"v-height",value:(240),expression:"240"}],ref:"visitChart"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }